import { render, staticRenderFns } from "./TextEditorField.vue?vue&type=template&id=12a22f41&"
import script from "./TextEditorField.vue?vue&type=script&lang=js&"
export * from "./TextEditorField.vue?vue&type=script&lang=js&"
import style0 from "./TextEditorField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports